/*
 * Recomendaciones del carrito.
 *
 * 31-ago-2026: antes pedia la recomendacion AUTOMATICA de Shopify. Ahora pide
 * primero los complementarios puestos a mano (salen de la co-compra medida sobre
 * 12 meses de pedidos) y solo si ese producto no tiene ninguno cae a la
 * automatica de siempre. Ver actuacion 2 del informe OFM-TDA-2608.
 */
class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    this.generateRecommendations();
  }

  async generateRecommendations() {
    const form = document.getElementById("AjaxCartForm");
    if (!form) return;

    const cartItems = form.querySelectorAll("[data-js-cart-item]");
    if (cartItems.length === 0) return;

    const base = `${KROWN.settings.routes.product_recommendations_url}?section_id=${this.dataset.section}&product_id=${cartItems[0].dataset.productId}&limit=${this.dataset.limit}`;

    for (const url of [`${base}&intent=complementary`, base]) {
      try {
        const response = await fetch(url);
        const text = await response.text();
        const innerHTML = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("[data-js-cart-recommendations-performed]");

        if (innerHTML && innerHTML.querySelectorAll("[data-js-product-item]").length > 0) {
          this.innerHTML = innerHTML.innerHTML;
          return;
        }
      } catch (e) {
        /* si falla una via, se prueba la siguiente */
      }
    }
  }
}

customElements.define("cart-recommendations", CartRecommendations);
